import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

export const DonateCallout = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <section ref={ref} data-testid="donate-callout" className="relative overflow-hidden bg-ink text-sand">
      <motion.img style={{ y }} src="/img/coast.jpg" alt="" aria-hidden="true" className="absolute inset-0 h-[125%] w-full object-cover opacity-50" />
      <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/80 to-ink/20" />
      <div className="relative mx-auto max-w-[1440px] px-5 py-28 sm:px-10 lg:py-44">
        <Reveal>
          <p className="eyebrow text-amber">Give</p>
          <h2 className="mt-6 max-w-3xl font-display text-5xl font-medium leading-[0.95] tracking-tight sm:text-7xl lg:text-8xl">
            Every gift keeps <span className="italic text-ochre">culture</span> strong.
          </h2>
          <p className="mt-8 max-w-lg text-base text-sand/85 md:text-lg">Donations help us run training, mentoring and cultural programmes for our community.</p>
          <Link to="/donate" data-testid="callout-donate-button" className="btn-ochre group mt-10">
            Make a pledge <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
